/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: 小乐主题风格3
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-07-04 17:13:19
 * @LastEditTime: 2022-12-28 17:41:53
 * @FilePath: /client-h5-v2/src/theme/xiaole/theme3.ts
 */
export default {
  'name': 'xiaoleTheme3',
  // 默认全局背景色
  'default-global-bg-color': '#3c3b3e',
  // 纯文本颜色
  'kd-text-color': '#FFFFFF',
  'kd-text-hover-color': '#ccc',
  'kd-text-tips-color': '#909399',
  // 链接颜色
  'kd-link-color': '#92C1E9',
  'kd-link-hover-color': '#BEDAF2',
  'kd-link-active-color': '#749ABA',
  // icon 颜色
  'kd-icon-color': '#ffffff',
  // 按钮
  'kd-btn-text-color': '#ffffff',
  'kd-btn-text-hover-color': '#cccccc',
  'kd-btn-bg-color': '#333F48',
  'kd-btn-bg-hover-color': '#4a4a4a',
  'kd-btn-bd-color': '#333F48',
  'kd-btn-bd-hover-color': '#4a4a4a',
  // 顶部导航
  'kd-nav-bg-color': '#000000',
  'kd-nav-text-color': '#ffffff',
  'kd-nav-text-hover-color': '#cccccc',
  // 侧边栏
  'kd-slider-nav-bg-color': 'linear-gradient(161deg, #000000 0%, #000000 100%)',
  'kd-slider-nav-bd-color': 'linear-gradient(161deg, #333F48 0%, #333F48 100%)',
  'kd-slider-qlink-text-color': '#ffffff',
  'kd-slider-qlink-text-hover-color': '#70787F',
  'kd-slider-logo-text-color': '#ffffff',
  'kd-slider-qlink-bg-color': '#333F48',
  'kd-slider-qlink-bg-hover-color': '#70787F',
  // 对话区域header
  'kd-dialog-header-banner-text-color': '#ffffff',
  'kd-dialog-header-banner-bg-color': '#000000',
  'kd-dialog-header-banner-bd-color': '#333F48',
  // 对话区域middle
  'kd-dialog-middle-bg-color': 'linear-gradient(161deg, #000000 0%, #000000 100%)',
  'kd-dialog-middle-bd-color': '#333F48',
  // 对话区域bottom（input框）
  'kd-input-wrap-bg-color': '#333F48',
  'kd-input-text-color': '#ffffff',
  'kd-input-bg-color': '#333F48',
  'kd-input-bd-color': '#333F48',
  'kd-input-bd-hover-color': '#ffffff',
  // 对话答案模版
  'kd-template-bg-color': '#333F48',
  'kd-template-text-color': '#ffffff',
  'kd-template-body-color': '#ffffff',
  'kd-template-bd-color': '#cccccc',
  // send 按钮（对话框主体）
  'kd-send-btn-text-color': '#ffffff',
  'kd-send-btn-bg-color': '#4E6EF2',
  'kd-send-btn-bg-hover-color': '#6d84e3',
  'kd-send-btn-bd-color': '#4E6EF2',
  'kd-send-btn-bd-hover-color': '#6d84e3',
  'kd-send-tips-text-color': '#b3aeae',
  // survey模版主题
  'kd-survey-bg-color': '#ffffff',
  'kd-survey-text-color': '#000000',
  // survey模版主题-单选框横向的样式
  'kd-survey-radio-text-color': '#000000',
  'kd-survey-radio-active-text-color': '#000000',
  'kd-survey-radio-bg-color': 'rgba(0,0,0,0)',
  'kd-survey-radio-active-bg-color': '#FFCA7A',
  'kd-survey-radio-bd-color': '#A0A0A0',
  'kd-survey-radio-active-bd-color': '#FFCA7A',
  // survey模版主题-多选框横向的样式
  'kd-survey-checkbox-text-color': '#000000',
  'kd-survey-checkbox-active-text-color': '#000000',
  'kd-survey-checkbox-bg-color': 'rgba(0,0,0,0)',
  'kd-survey-checkbox-active-bg-color': '#FFEBCC',
  'kd-survey-checkbox-bd-color': '#A0A0A0',
  'kd-survey-checkbox-active-bd-color': '#FFEBCC',
  // 智联-survey 客服满意度评价样式
  'kd-survey-zhilian-engineerInfo-bg-color': 'rgba(213, 238, 255, 1)',
  'kd-survey-zhilian-engineerInfo-text-color': 'rgba(8, 41, 249, 1)'
}
